module.exports = __webpack_public_path__ + "img/Residential bungalow - Gadhinglaj.9effa98f.jpg";